import { useEffect } from 'react';
import GTM from 'react-gtm-module';

let initialized = false;

const useGoogleTagManager = () => {
  const { pathname } = window.location;

  useEffect(() => {
    const gtmId = import.meta.env.VITE_GTM;

    if (!gtmId) {
      return;
    }

    GTM.initialize({ gtmId });

    if (!initialized) {
      const gtmIdInitialized = import.meta.env.VITE_GTM;
      if (gtmIdInitialized === undefined) {
        throw new Error('GTM ID is not defined');
      }

      const datalayerGTM = (e: ErrorEvent) => {
        GTM.dataLayer({
          dataLayer: {
            event: 'error',
            message: e.message,
            stacktrace: e.error?.stack,
            path: pathname,
          },
        });
      };

      // Track basic JavaScript errors
      window.addEventListener('error', datalayerGTM);

      initialized = true;
    }

    if (!initialized) {
      throw new Error('GTM is not initialized');
    }
  }, []);

  useEffect(() => {
    const userToken = sessionStorage.getItem('token');
    const clientNumber = userToken ? atob(userToken).split(':')[0] : undefined;
    GTM.dataLayer({
      dataLayer: {
        event: 'pageChange',
        page: {
          url: pathname,
        },
        clientNumber,
      },
    });
  }, [pathname]);

  return { GTM };
};

export { useGoogleTagManager };
